import { ClassNames, css } from '@prose-ui/legacy';

import ScaleLoader from './ScaleLoader';

const rootStyles = css({
  width: '100%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  height: '100%',
});

type AccountLoaderProps = {
  classes?: {
    accountLoaderContainer?: string;
  };
};

export const AccountLoader = ({ classes }: AccountLoaderProps) => {
  return (
    <ClassNames>
      {({ cx, css }) => (
        <div className={cx(css(rootStyles), classes?.accountLoaderContainer)}>
          <ScaleLoader />
        </div>
      )}
    </ClassNames>
  );
};
